<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="userGroupsState.loading"
          :style="{ opacity: userGroupsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay grupos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    ...mapGetters('List', [
      'userGroupsState'
    ]),
    optionSelected() {
      const ONE_GROUP = 1;
      if (this.userGroupsState.list.length === ONE_GROUP) {
        if (this.userGroupsState.list[0].isOffice !== 'Y') {
          const group = this.userGroupsState.list[0];
          this.$emit('input', group?.value);
          return group;
        }
      }
      return this.userGroupsState.list
        .filter((group) => group.isOffice !== 'Y')
        .find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.userGroupsState.list.length
        || this.userGroupsState.loading;
    },
    listOptions() {
      if (this.onlyGroups) {
        return this.userGroupsState.list
          .filter((group) => group.isOffice === 'N' || group.isOffice === 'false');
      }
      return this.userGroupsState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    onInput(event) {
      console.log('event', event)
      this.$emit('full-group', event);
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.userGroupsState.list.find((option) => option.value === this.value);
    }
  },
  async created() {
    await this.fetchUserGroups();
  },
  props: {
    name: { type: String, required: true },
    autocomplete: { type: Boolean, default: false },
    label: { type: String, default: 'Grupos a los que perteneces' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    onlyGroups: { type: Boolean, default: false }
  }
};

</script>
